import React from "react";
import styled from "styled-components";

const Wrap = styled.div`
  text-align: center;
  margin-bottom: 16px;
`;

const Brand = styled.div`
  display: flex;
  justify-content: center;
  align-items: baseline;
  gap: 10px;

  .kakao {
    color: #f4c542;   /* 브랜드 옐로우 */
    font-size: 22px;
    font-weight: 900;
  }
  .name {
    color: #111;
    font-size: 22px;
    font-weight: 900;
  }
`;

const Sub = styled.div`
  margin-top: 8px;
  font-size: 16px;
  font-weight: 800;
  color: #111;
`;

export default function BrandHeader({ subtitle }) {
    return (
        <Wrap>
            <Brand>
                <span className="kakao">kakaoT</span>
                <span className="name">Hey’ Way</span>
            </Brand>
            <Sub>{subtitle}</Sub>
        </Wrap>
    );
}
